import React from 'react'
import { Button, Link, Text } from '@radix-ui/themes'
import { Link as RouterLink } from 'react-router-dom'
import { DataTestIDs } from 'shared/constants'
import styles from '../notification.module.scss'

interface Props {
  buttonText: string | null
  onClick: (() => void) | null
}

export const NotificationToastActionButton: React.FC<Props> = ({
  buttonText,
  onClick
}) => {
  if (!buttonText || !onClick) return null

  return (
    <Button
      onClick={onClick}
      className={styles.actionButton}
      data-testid={DataTestIDs.notificationButton}
    >
      <Text
        size={'2'}
        weight={'bold'}
      >
        {buttonText}
      </Text>
    </Button>
  )
}

/** A path of this app (`/rewards#daily-tasks`), not an address elsewhere. */
const isAppPath = (address: string) =>
  address.startsWith('/') && !address.startsWith('//')

export const NotificationToastLink = ({
  linkText,
  address,
  onFollow
}: {
  linkText?: string
  address?: string
  /** A path of this app was followed (the toast closes). */
  onFollow?: () => void
}) => {
  if (!linkText || !address) return null

  const text = (
    <Text
      size={'2'}
      weight={'bold'}
    >
      {linkText}
    </Text>
  )

  // NOTE: a path of this app opens in this tab; an address elsewhere in a new one
  if (isAppPath(address)) {
    return (
      <Button
        asChild
        className={styles.actionButton}
      >
        <RouterLink
          to={address}
          onClick={onFollow}
          data-testid={DataTestIDs.notificationButton}
        >
          {text}
        </RouterLink>
      </Button>
    )
  }

  return (
    <Link
      href={address}
      target='_blank'
      rel='noreferrer noopener'
    >
      <Button className={styles.actionButton}>{text}</Button>
    </Link>
  )
}
